import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logOut } from './actions/AuthAction';
import { useDispatch } from 'react-redux';

export default function SessionChecker() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const excludedRoutes = ["/", "/landing", "/auth", "/auth/reset-password"];

    useEffect(() => {
        // If the user is on an excluded route, do not run session checking
        if (excludedRoutes.includes(location.pathname)) {
            return;
        }

        const checkSession = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/check-session`, {
                    method: 'GET',
                    credentials: 'include'
                });

                if (!response.ok) {
                    throw new Error('Session expired');
                }
            } catch (error) {
                console.log("User is logged out due to missing token");
                dispatch(logOut());
            }
        };

        // Run on refresh
        checkSession();

        // Run every minute
        const interval = setInterval(checkSession, 60 * 1000);
        return () => clearInterval(interval); // Cleanup interval
    }, [navigate, location.pathname]);

    return null;
}
